<script setup>
import { computed } from 'vue'
import Icon from './Icon.vue'

const props = defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    wrapperClass: {
        type: String,
    }
})

const newItems = computed(() => {
    let items = []

    props.items.forEach((item, index) => {
        items.push(item)

        if (index + 1 < props.items.length) {
            items.push({ arrowIcon: true, name: 'chevronRight' })
        }
    })
    return items
})
</script>

<template>
    <div class="flex items-center gap-2 mb-5" :class="wrapperClass">
        <div v-for="(item, index) in newItems" :key="index">

            <!-- icon -->
            <router-link v-if="item.icon" :to="{ name: item.route?.name }" class="p-1 text-[#667085] flex items-center justify-center">
                <Icon :name="item.name" size="20px" />
            </router-link>

            <!-- next arrow -->
            <div v-else-if="item.arrowIcon" class="text-[#D0D5DD] flex items-center justify-center">
                <Icon :name="item.name" size="16px" />
            </div>

            <!-- text -->
            <router-link :to="{ name: item.route?.name, params: item.params || {} }"
             v-else class="text-[#344054] text-sm font-semibold rounded-md py-1 px-2" :class="{ 'bg-[#F9FAFB]': newItems.length == index + 1 }">{{ item.name }}</router-link>

        </div>
    </div>
</template>